<template>
  <div class="body-width divcss5">
    <div>
      <div class="div-row div-bottom news-Medium-24">
        大连海大智龙科技有限公司举行揭牌仪式
        <!-- <span class="news-Regular-14">作者：何舒 来源：科技处 添加时间：2019-05-09 09:13:27</span> -->
      </div>
        <div class="div-text-left news-Regular-14b6">
            <span>2019-05-09</span><span class="div-padding-left">大连海大智龙科技有限公司</span>
           </div>
      <div class="div-line  divcss5">
      
      </div>
      <div class="div-row div-bottom10  div-top30">
        <div class="  div-top box2">
          <div class="div-margin " >
            <img src="../../../assets/images/news1/news2.png" />
          </div>
        </div>
      </div>
      <div class="div-row div-bottom30">
        <p class="indentation">
          5月8日上午，由学校尹勇教授团队“高品质航海模拟器及其开发平台系统”国家发明专利的知识产权投资入股注册组建的“大连海大智龙科技有限公司”在海事科技大厦举行揭牌仪式。大连市科技局巡视员姜斯进、大连高新园区管委会副主任原驰、学校副校长王小勇出席活动。
        </p>
      </div>
      <div class="div-row">
        <div class="  div-top box2">
          <div class="div-margin " >
            <img src="../../../assets/images/news1/news1.png" />
          </div>
        </div>
      </div>
      <div class="div-row div-bottom30">
        <p class="indentation">
          王小勇代表学校致辞。他对市科技局和高新园区管委会长期以来的大力支持表示感谢。他简要介绍了学校近两年通过完善制度、优化机制、简化程序等方式有效激发科研团队科技成果转化热情，取得的初步成效。他希望在市科技局和高新园区管委会的继续支持下，加速学校科技成果本地转化，助力大连“两先区”建设。
        </p>
        <p class="indentation">
          姜斯进充分肯定了学校在大连市科技创新中起到的重要作用。他表示，市科技局会进一步从创新政策供给、科技经费支持等方面为学校科研项目的实施提供服务和保障，希望学校进一步加大科技成果本地转化，努力为创新创业创投做出贡献。</p>
        <p class="indentation">
          原驰充分肯定了学校在产业化工作中取得的阶段性成绩。他介绍了目前园区在优势项目进驻高新区、双创活动等方面出台的一系列优惠条件和政策，希望通过与学校在船舶海洋制造领域的合作，对高新区“中国制造2025创新中心”的发展起到积极的推动作用。
        </p>
      </div>
      <div class="div-row">
        <div class=" div-top box2">
          <div class="div-margin " >
            <img src="../../../assets/images/news1/news3.png" />
          </div>
        </div>
      </div>
      <div class="div-row div-top30 ">
        <p class="indentation div-top0">揭牌仪式结束后，与会人员参观了大连海大智龙科技有限公司、船舶导航系统国家工程研究中心、海底工程中心、航海模拟器和轮机模拟器。</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        isflag1: true,
        isflag2: false,
        isflag3: false
      };
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll)
    },
    methods: {
      handleScroll() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if (parseInt(scrollTop) >= 550 && parseInt(scrollTop) < 1200) {
          // alert(scrollTop)
          this.isflag2 = true;
        }
        if (parseInt(scrollTop) >= 1200) {
          this.isflag3 = true;
        }

      },
      destroyed() {
        window.removeEventListener('scroll', this.handleScroll)
      },
    },
  };

</script>

<style scoped>
  .fl {
    float: right;
    margin-right: 20px;
  }

  .fy {
    text-align: center;
    margin-top: 30px;
  }

  .title {
    height: 100%;
  }

  .div-width {
    width: 75%;
  }


  .div-line {
    background: #e6e6e6;
    height: 1px;
    width: 100%;

  }

  .div-bottom10 {
    padding-top: 10px;
  }

  .div-bottom30 {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .div-top30 {
    padding-top: 30px;
  }

.div-padding-left{
  padding-left: 36px;
}
.div-top30{
  margin-top: 30px;
}
.div-top0{
  margin-bottom: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/contentcoms/news2019/news1.vue